export default __webpack_public_path__ + "static/media/numberThree.e8df0ff3.svg";